import React, { useEffect, useRef, useState } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import { Player } from 'ThreeTerminal_mobile_dynamic';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';

/* eslint-disable */
const PC = allData.pc;
/* eslint-disable */

const styles = require(PC ? '../../../../pc/index/layout/block.css' : './index.css').default;

const SlideArrow = errorBoundary(props => {
    const { slide } = props;

    if (!PC) return null;

    return (
        <div className={styles.SlideArrows}>
            <img src={require('./assets/arr_l.png')} alt="" onClick={() => slide.current.slickPrev()} />
            <img src={require('./assets/arr_r.png')} alt="" onClick={() => slide.current.slickNext()} />
        </div>
    );
});

const Flow = errorBoundary(({ content }) => {
    return (
        <div className={styles.Flow}>
            <div className={styles.headtitle}>
                <div>-&nbsp;&nbsp;博鳌旅游传播论坛&nbsp;&nbsp;-</div>
                <span>
                    <img src={require('./assets/title_line.png')} alt="" />
                </span>
            </div>
            <div className={styles.table}>
                <div className={styles.title}>
                    <div>时间</div>
                    <div>内容</div>
                </div>
                <div className={styles.content}>
                    {content.map((item, index) => (
                        <div key={index} className={styles.items}>
                            <div>{item.time}</div>
                            <div>{item.content}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
});

const News = errorBoundary(({ content }) => {
    return (
        <div className={styles.News}>
            <div className={styles.headtitle}>
                <div>-&nbsp;&nbsp;新闻动态&nbsp;&nbsp;-</div>
                <span>
                    <img src={require('./assets/title_line.png')} alt="" />
                </span>
            </div>
            <div className={styles.content}>
                {content.map((item, index) => (
                    <div key={index} className={styles.items} onClick={() => (location.href = item.url)}>
                        <div className={styles.pic}>
                            <LazyImg src={item.thumbnail} alt="" />
                        </div>
                        <div className={styles.text}>
                            <div>{item.title}</div>
                            <div>{item.newsTime.slice(11, 16)}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
});

const SlideBox = {
    Dots: errorBoundary(({ content, SP, active }) => {
        const arr = new Array(Math.ceil(content.length / SP)).fill(0);

        return (
            <div className={styles.slideDots}>
                {arr.map((item, index) => (
                    <div key={index} className={`${styles.dot} ${index === active ? styles.active : null}`} />
                ))}
            </div>
        );
    }),
    SlideData: ({ content, SP, SlideItem }) => {
        let data = content.slice();
        let result = [];

        for (let index = 0; index < data.length; index += SP) {
            result.push(<SlideItem key={index} content={data.slice(index, index + SP)} />);
        }

        return result;
    },
};

const Stars = errorBoundary(({ content }) => {
    const [active, setActive] = useState(0);
    const slide = useRef(null);
    const SP = PC ? 12 : 9;

    const slideSettings = {
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        arrows: false,
        afterChange: index => setActive(index),
    };

    const SlideItem = errorBoundary(({ content }) => {
        return (
            <div className={styles.slideContent}>
                {content.map((item, index) => (
                    <div key={index} className={styles.items} onClick={() => (location.href = item.videoPlayUrl)}>
                        <div className={styles.pic}>
                            <LazyImg src={item.posterUrl || item.thumbnail} alt="" />
                            <LazyImg src={require('./assets/play_s.png')} alt="" />
                        </div>
                        <div className={styles.text}>{item.title}</div>
                    </div>
                ))}
            </div>
        );
    });

    return (
        <div className={styles.Stars}>
            <div className={styles.headtitle}>
                <div>-&nbsp;&nbsp;明星助力&nbsp;&nbsp;-</div>
                <span>
                    <img src={require('./assets/title_line.png')} alt="" />
                </span>
            </div>
            <SlideArrow slide={slide} />
            <div className={styles.content}>
                <Slider ref={slide} {...slideSettings}>
                    {SlideBox.SlideData({ content, SP, SlideItem })}
                </Slider>
                <SlideBox.Dots content={content} SP={SP} active={active} />
            </div>
        </div>
    );
});

const Pics = errorBoundary(({ content }) => {
    const [active, setActive] = useState(0);
    const slide = useRef(null);
    const SP = 1;

    const slideSettings = {
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        centerMode: !PC,
        slidesToShow: 1,
        arrows: false,
        className: styles.picFix,
        centerPadding: '5%',
        afterChange: index => setActive(index),
    };

    const SlideItem = errorBoundary(({ content }) => {
        let pic = content[0];

        return (
            <div className={styles.slideContent}>
                <img src={pic.thumbnail} alt="" onClick={() => (location.href = pic.url)} />
                <img
                    className={styles.scale}
                    src={require('./assets/scale.png')}
                    onClick={() => (location.href = pic.url)}
                    alt=""
                />
            </div>
        );
    });

    return (
        <div className={styles.Pics}>
            <div className={styles.headtitle}>
                <div>-&nbsp;&nbsp;精彩图集&nbsp;&nbsp;-</div>
                <span>
                    <img src={require('./assets/title_line.png')} alt="" />
                </span>
            </div>
            <SlideArrow slide={slide} />
            <div className={styles.content}>
                <Slider ref={slide} {...slideSettings}>
                    {SlideBox.SlideData({ content, SP, SlideItem })}
                </Slider>
                <SlideBox.Dots content={content} SP={SP} active={active} />
            </div>
        </div>
    );
});

const Live = errorBoundary(({ content }) => {
    const [active, setActive] = useState(0);
    const slide = useRef(null);
    const SP = !PC ? 3 : 5;

    const slideSettings = {
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        arrows: false,
        afterChange: index => setActive(index),
    };

    const MainVideo = errorBoundary(({ content }) => {
        const isLive = content[0].type === 'live';
        const liveid = isLive ? content[0].liveId : null;
        const LiveURL = PC
            ? `https://flive.ifeng.com/video/1004980.html`
            : `https://flive.ifeng.com/video/1004980.html`;

        console.log('content[0]', content[0]);

        return (
            <div className={styles.mainVideo}>
                <div className={styles.video}>
                    <div className={styles.player}>
                        {!isLive ? (
                            <Player
                                playermsg={{}}
                                videoConfig={{
                                    vid: content[0].guid,
                                    duration: content[0].duration,
                                    bigPosterUrl: content[0].thumbnail,
                                    videoPlayUrl: content[0].videoPlayUrl,
                                    title: content[0].title,
                                    autoPlay: true,
                                    dotsAction: 'hover',
                                    autoplay: true,
                                    autoplayInterval: 6000,
                                    speed: 1000,
                                }}
                            />
                        ) : (
                            <div className={styles.live}>
                                <iframe width="100%" height="100%" src={LiveURL} frameBorder="0" />
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.btn} onClick={() => (location.href = content[0].url)}>
                    <img src={require('./assets/video_c.png')} alt="" />
                    <span>点击观看直播</span>
                </div>
            </div>
        );
    });

    const SlideItem = errorBoundary(({ content }) => {
        return (
            <div className={styles.slideContent}>
                {content.map((item, index) => (
                    <div
                        key={index}
                        className={styles.items}
                        onClick={() => (location.href = item.videoPlayUrl || item.url)}>
                        <div className={styles.pic}>
                            <LazyImg src={item.posterUrl || item.thumbnail} alt="" />
                            <LazyImg src={require('./assets/play_s.png')} alt="" />
                        </div>
                        <div className={styles.text}>{item.title}</div>
                    </div>
                ))}
            </div>
        );
    });

    return (
        <div className={styles.Live}>
            <div className={styles.headtitle}>
                <div>-&nbsp;&nbsp;论坛盛况&nbsp;&nbsp;-</div>
                <span>
                    <img src={require('./assets/title_line.png')} alt="" />
                </span>
            </div>
            <SlideArrow slide={slide} />
            <div className={styles.content}>
                <MainVideo content={content} />
                <Slider ref={slide} {...slideSettings}>
                    {SlideBox.SlideData({ content, SP, SlideItem })}
                </Slider>
                <SlideBox.Dots content={content} SP={SP} active={active} />
            </div>
        </div>
    );
});

const Talk = errorBoundary(({ content }) => {
    return (
        <div className={styles.Talk}>
            <div className={styles.headtitle}>
                <div>-&nbsp;&nbsp;嘉宾发言&nbsp;&nbsp;-</div>
                <span>
                    <img src={require('./assets/title_line.png')} alt="" />
                </span>
            </div>
            <div className={styles.TalkInnner}>
                {content.map((item, index) => (
                    <div key={index} className={styles.items} onClick={() => (location.href = item.url)}>
                        <div className={styles.pic}>
                            <LazyImg src={item.thumbnail} alt="" />
                        </div>
                        <div className={styles.text}>
                            <div>{item.title}</div>
                            <div>{item.newsTime?.slice(11, 16)}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
});

const Talk2 = errorBoundary(({ content }) => {
    return (
        <div className={styles.Talk}>
            <div className={styles.headtitle}>
                <div>-&nbsp;&nbsp;现场访问&nbsp;&nbsp;-</div>
                <span>
                    <img src={require('./assets/title_line.png')} alt="" />
                </span>
            </div>
            <div className={styles.TalkInnner}>
                {content.map((item, index) => (
                    <div key={index} className={styles.items} onClick={() => (location.href = item.url)}>
                        <div className={styles.pic}>
                            <LazyImg src={item.thumbnail} alt="" />
                        </div>
                        <div className={styles.text}>
                            <div>{item.title}</div>
                            <div>{item.newsTime?.slice(11, 16)}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
});

const Prize = errorBoundary(({ content }) => {
    console.log('Prize-content', content);

    // const Title = errorBoundary(({ content }) => {
    //     console.log('Title-content', content);
    //     const createMarkup = () => {
    //         return { __html: this.props.content };
    //     };

    //     return (
    //         <div dangerouslySetInnerHTML={createMarkup()} />
    //     );
    // });

    return (
        <div className={styles.Talk}>
            <div className={styles.headtitle}>
                {/* <Chip id="221215" type="static" title="优质案例展示" groupName="优质案例展示" content={contactus}>
                    <Title />
                </Chip> */}
                {/* <ChipEdit transform={transform} /> */}
                <div>-&nbsp;&nbsp;优质案例展示&nbsp;&nbsp;-</div>
                <span>
                    <img src={require('./assets/title_line.png')} alt="" />
                </span>
            </div>
            <div className={styles.TalkInnner}>
                {/* <LazyImg src={require('./assets/640.png')} alt="" /> */}
                {content.map((item, index) => (
                    <div key={index} className={styles.items} onClick={() => (location.href = item.url)}>
                        <div className={styles.pic}>
                            <LazyImg src={item.thumbnail} alt="" />
                        </div>
                        <div className={styles.text}>
                            <div>{item.title}</div>
                            <div>{item.newsTime?.slice(11, 16)}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
});

const Prize2 = errorBoundary(({ content }) => {
    return (
        <div className={styles.Talk}>
            <div className={styles.headtitle}>
                <div>-&nbsp;&nbsp;案例发言&nbsp;&nbsp;-</div>
                <span>
                    <img src={require('./assets/title_line.png')} alt="" />
                </span>
            </div>
            <div className={styles.TalkInnner}>
                {content.map((item, index) => (
                    <div key={index} className={styles.items} onClick={() => (location.href = item.url)}>
                        <div className={styles.pic}>
                            <LazyImg src={item.thumbnail} alt="" />
                        </div>
                        <div className={styles.text}>
                            <div>{item.title}</div>
                            <div>{item.newsTime?.slice(11, 16)}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
});

const PrizeList = errorBoundary(({ content }) => {

    return (
        <div className={styles.Talk}>
            <div className={styles.headtitle}>
                {/* <Chip id="221215" type="static" title="优质案例展示" groupName="优质案例展示" content={contactus}>
                    <Title />
                </Chip> */}
                {/* <ChipEdit transform={transform} /> */}
                <div>-&nbsp;&nbsp;优质案例名单&nbsp;&nbsp;-</div>
                <span>
                    <img src={require('./assets/title_line.png')} alt="" />
                </span>
            </div>
            <div className={styles.TalkInnner}>
                <LazyImg src={require('./assets/640.jpg')} alt="" />
            </div>
        </div>
    );
});

export default {
    Flow,
    News,
    Stars,
    Live,
    Pics,
    Talk,
    Talk2,
    Prize,
    Prize2,
    PrizeList,
};
